import { HttpErrorResponse, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { APP_CONFIG } from '@improver/app-config';
import { ApiService, HTTP_HEADERS } from '@improver/core';
import { WeblogData } from './weblog.model';

const getWeblogData = (errorResponse: HttpErrorResponse, request: HttpRequest<any>): WeblogData => ({
  url: request.url,
  instance: request.headers.get(HTTP_HEADERS.INSTANCE_ID) || '',
  bearer: request.headers.get(HTTP_HEADERS.AUTHORIZATION),
  requestBody: JSON.stringify(request?.body || ''),
  requestId: request.headers.get(HTTP_HEADERS.REQUEST_ID) || '',
  responseCode: errorResponse.status.toString(10),
  responseBody: JSON.stringify(errorResponse?.message || ''),
});

@Injectable({ providedIn: 'root' })
export class WeblogErrorHandlerService {
  private readonly apiService: ApiService = inject(ApiService);
  private readonly improverAngularEnvironment = inject(APP_CONFIG);

  sendErrorToWeblog(errorResponse: HttpErrorResponse, request: HttpRequest<any>) {
    this.apiService
      .post(`${this.improverAngularEnvironment.services.authorization}/weblog`, getWeblogData(errorResponse, request))
      .subscribe();
  }
}
